module.exports = __webpack_public_path__ + "static/media/palmas.d87aabac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/palmas.png
// module id = 624
// module chunks = 0